import { ReactNode, Suspense } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PromotionRepeatText_promotion$key } from '../../../relay/__generated__/PromotionRepeatText_promotion.graphql';
import EnumPair from '../../core/EnumPair';
import Text, { TextProps } from '../../core/Text';

const PromotionRepeatText_promotion = graphql`
  fragment PromotionRepeatText_promotion on Promotion {
    isRepeat
    repeatValue
    repeatType
  }
`;

type Props = {
  promotion: PromotionRepeatText_promotion$key;
} & Omit<TextProps, 'children'>;

const PromotionRepeatText = ({ promotion, ...props }: Props) => {
  const { isRepeat, repeatValue, repeatType } = useFragment(PromotionRepeatText_promotion, promotion);

  const renderRepeat = () => {
    return [
      repeatType ? <EnumPair typename={'RepeatTypeEnum'}>{repeatType}</EnumPair> : null,
      repeatType && repeatValue ? (
        <EnumPair typename={repeatType === 'monthly' ? 'MonthDayEnum' : 'WeekdayEnum'}>{repeatValue}</EnumPair>
      ) : null,
    ].reduce((pre, value, currentIndex) => {
      if (!value) return pre;
      if (currentIndex === 0) return [value];
      else return [...pre, ' / ', value];
    }, [] as ReactNode[]);
  };

  return (
    <Suspense>
      <Text {...props}>{isRepeat ? renderRepeat() : '반복 없음'}</Text>
    </Suspense>
  );
};

export default PromotionRepeatText;
